import React from 'react';
import styles from './Invoicing.module.css';
import useScrollReveal from './hooks/useScrollReveal';
import Header from './Sections/Header';
import HowItWorks from './Sections/HowItWorks';
import FeatureBlocks from './Sections/FeatureBlocks';
import Capabilities from './Sections/Capabilities';
import Faq from './Sections/Faq';
import CallToAction from './Sections/CallToAction';

const Invoicing = () => {
  useScrollReveal('[data-sr]');

  return (
    <div className={styles.page}>
      <Header />
      <HowItWorks />
      <FeatureBlocks />
      <Capabilities />
      <Faq />
      <CallToAction />
    </div>
  );
};

export default Invoicing;
